// issue #162: ユーザ要望フォーム → score-engine POST /api/feedback。
// {title, body} を JSON で送る。res.ok なら void、非 ok は throw (呼び出し側で失敗表示)。
// GitHub の存在・PAT はこの層に一切現れない (backend の env のみで扱う)。

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export interface FeedbackRequest {
  title: string;
  body: string;
}

/** 要望を score-engine 経由で送信する。非 ok レスポンス / ネットワーク断は throw する。 */
export async function submitFeedback(req: FeedbackRequest): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title: req.title, body: req.body }),
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}
